import {
   TABLET_MIN_WIDTH,
   DESKTOP_MIN_WIDTH,
   MEDIUM_DESKTOP_MAX_WIDTH,
   MEDIUM_DESKTOP_MIN_WIDTH
} from '@flowwai-frontend/shared/constants'

export function isMobile(): boolean {
   if (window.innerWidth < TABLET_MIN_WIDTH) return true
   return false
}

export function isDesktop(): boolean {
   return window.innerWidth >= DESKTOP_MIN_WIDTH
}

export function isTabletOrMobile(): boolean {
   return window.innerWidth < DESKTOP_MIN_WIDTH
}

export const isMediumDesktop = (): boolean =>
   window.innerWidth >= MEDIUM_DESKTOP_MIN_WIDTH &&
   window.innerWidth < MEDIUM_DESKTOP_MAX_WIDTH

export const isLargeDesktop = (): boolean =>
   window.innerWidth >= MEDIUM_DESKTOP_MAX_WIDTH
